module.exports = __webpack_public_path__ + "img/natashahodgeshair.920ca0a2.png";